import { useCallback as r } from "react";
import { useFormik as o } from "../../../node_modules/formik/dist/formik.esm.js";
import e from "../../../node_modules/lodash-es/isEqual.js";
import s from "./utils/normalizeServerErrors.js";
import { throwServerError as i } from "./utils/throwServerError.js";
const t = "Помилка", a = (a2) => {
  const { initialValues: m = {}, validationSchema: n, options: l, onSubmit: u, onError: d, useMutation: c, normalizeRequestData: f, skipSubmitIfValuesIsEqual: p = true, shouldThrowServerError: v = true } = a2, [S, h] = c(), E = r(async (r2, o2) => {
    try {
      if (p && e(r2, m)) return u == null ? void 0 : u({ values: r2, formikHelpers: o2 }), void o2.resetForm();
      const s2 = f ? f(r2) : r2, i2 = await S(s2).unwrap();
      u == null ? void 0 : u({ values: r2, formikHelpers: o2, result: i2 }), o2.resetForm();
    } catch (r3) {
      v && i(r3);
      const e2 = Object.keys(m), a3 = s(r3, e2, t);
      a3 && o2.setErrors(a3), d == null ? void 0 : d(r3);
    }
  }, [p, m, f, S, u, v, d]);
  return { ...o({ ...l, initialValues: m, validationSchema: n, onSubmit: E }), isLoading: h == null ? void 0 : h.isLoading, error: h == null ? void 0 : h.error };
};
export {
  a as useFormikWithMutation
};
//# sourceMappingURL=useFormikWithMutation.js.map
